import { fetcher } from "utils/ApiUtil";

export interface IWeddingDateInfo {
  wantToMonth?: string[];
  wantToTime?: string[];
  wantTotHeadCount?: string[];
  wantToHeadCountOption?: string[];
  wantToDay?: string[];
  HeadCountOptionText?: string;
  wantWeddingHallName?: string;
  wantWeddingHallType?: string;
}

export interface ICounselingDateInfo {
  [key: string]: string | null;
}

interface IList {
  contructor_no: number;
  contructor_hall: number[];
}
export interface ISendData {
  list: IList[];
  title?: string;
  bride_name: string;
  bride_phone: number;
  groom_name: string;
  groom_phone: number;
  wedding_day?: string;
  filming_day?: string;
  extra_data: [
    { title: string; category: string; content: string },
    { title: string; content?: string },
    { title: string; category: string; content?: string },
    { title: string; content?: string; category: string },
    { title: string; content?: string; category: string },
    { title: string; content?: string; category: string }
  ];
}

export interface IFittableWedding {
  wantCity: string[];
  wantLocation: string[];
  wantWeddingHallType: string[];
  wantConcurrent: string[];
  wantMenu: string[];
  wantPeriod: string[];
  expectCount: string[];
}

interface IWeddingHallFilterItem {
  no: 1;
  content: string;
}

export interface IWeddingHallFilter {
  [key: string]: {
    title: string;
    list: IWeddingHallFilterItem[];
  };
}

export interface ICompanyLocationFilter {
  location_1: string;
  location_2: string[];
}

export interface ICompanyEvent {
  title: string;
  sub_title?: string;
  link?: string;
  icon?: string;
}

export async function contructorHallFilter() {
  return await fetcher<IWeddingHallFilter>("/api/contructor/getHallFilterList");
}

export async function contructorLocationFilter() {
  return await fetcher<{ result: ICompanyLocationFilter[] }>(
    "/api/contructor/getLocation"
  );
}

export async function contructorEventList() {
  return await fetcher<ICompanyEvent[]>("/api/contructor/getEventList");
}
